import React from 'react';
import { useGetSourceTenantMappings } from './projectSwitcher.selectors';
import useSessionStorageProject from './useSessionStorageProject';
import { getTenantId, setTenantId } from '@innovyze/lib_get_service';
import { datadogLogs } from '@datadog/browser-logs';

export default function SetTenantIdFromProjectSourceId() {
	const sourceTenantMappings = useGetSourceTenantMappings();
	const { source, debounceResetSource: resetSourceAfterLastRender } =
		useSessionStorageProject(1000);

	React.useEffect(() => {
		if (sourceTenantMappings && source) {
			const targetTenantId = sourceTenantMappings?.[source];
			const oldTenantId = getTenantId();

			if (targetTenantId) {
				setTenantId(targetTenantId);

				datadogLogs.logger.info(
					`Tenant ID from projectSourceId set successfully to tenantId: ${targetTenantId}`,
					{
						targetTenantId,
						source,
						sourceTenantMappings,
						oldTenantId,
					},
				);

				resetSourceAfterLastRender();
			}
		}
	}, [sourceTenantMappings, source]);

	return <></>;
}
